class TagFilter {
	constructor(el) {
		this.$el = $(el)
		this.$panel = this.$el.parents('.tabs__panel')
		this.$list = this.$panel.find('.tag-list')
		this.$up = this.$list.find('.ico.ico-arrow-up')

		this.templates = {
			found: '<ul class="found"></ul>',
			notfound: '<div class="notfound">Nothing found</div>'
		};
	}

	init() {
		this.$el.on('input', this.change.bind(this))
		this.$up.on('click', this.up.bind(this))

		if (!this.exist(this.$el)) {
			this.generate(this.$panel)
		}

		this.filter(this.$el)
	}

	up() {
		$('body,html').scrollTop(300).animate({
			scrollTop: 0
		}, 200);
	}

	exist($el) {
		var $found = $el.find('.found')
		var $notfound = $el.find('.notfound')
		var exist = $found.length > 0 && $notfound.length > 0

		if (exist) {
			this.$found = $found;
			this.$notfound = $notfound;
		}

		return exist
	}

	generate($parent) {
		this.$found = $(this.templates['found']).hide();
		this.$notfound = $(this.templates['notfound']).hide();

		$parent.append(this.$found);
		$parent.append(this.$notfound);
	}

	change(e) {
		let $this = $(e.target);

		this.filter($this);
	}

	filter($target) {
		const val = $target.val()

		if (val === '') {
			return this.restore();
		}

		const $filtred = this.$list.find('a').filter(function(index) {
			return $(this).text().toLowerCase().indexOf(val.toLowerCase()) !== -1;
		})

		if ($filtred.length === 0) {
			return this.notfound();
		}

		this.found($filtred);
	}

	found($filtred) {
		let $liItems = $filtred.parent().clone();
		let $relevanted = this.relevant($liItems);

		let columnAction = $relevanted.length > 15 ? 'addClass' : 'removeClass';

		this.$list.hide();
		this.$notfound.hide();
		this.$found.html($relevanted)[columnAction]('found-column').show();
	}

	relevant($items) {
		var self = this;

		$items.sort(function(a, b) {
			var $el = $(a);
			var text = $el.text();
			var splited = text.split(' ');
			var tag = splited[0];

			return tag === self.val ? -1 : 1;
		});

		return $items;
	}

	notfound(filtred) {
		this.$found.hide().removeClass('found-column');
		this.$list.hide();
		this.$notfound.show();
	}

	restore($filtred) {
		this.$found.hide().removeClass('found-column');
		this.$notfound.hide();
		this.$list.show();
	}
}

export default class TagList {
	constructor(el) {
		this.$el = $(el)
		this.$filters = this.$el.find('.tabs__panel .tag-filter')

		this.filters = this.$filters.toArray().map(el => new TagFilter(el))
	}

	init() {
		this.filters.forEach(filter => {
			filter.init()
		})

		return this
	}
}


// WEBPACK FOOTER //
// ./src/desktop/scripts/components/tagList.js